import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Platform, Modal, Pressable, Text, StyleSheet, View } from "react-native";
import { Str_DelAndClean, Str_DelChat, Str_MarkRead, Str_TopicTop, Str_TopicUntop } from "../language/string_res";
import * as ImSdk from "../../imsdk/api";
import { TopicWithSummary } from "../../imsdk/api/topic";
import time from "../../imsdk/time";
import { hideLoading, showLoading } from "./Loading";

interface SwipeableItemProps {
    children: React.ReactNode
    topicSummary: TopicWithSummary
}
// 暴露关闭方法
export interface SwipeableItemRef {
    close: () => void;
}

export const SwipeableItem = forwardRef<SwipeableItemRef, SwipeableItemProps>(
    ({  children, topicSummary }, ref) => {
        useImperativeHandle(ref, () => ({ close: () => {} }));
        const im = ImSdk.getInstance();
        const { topic, summary } = topicSummary;
        const unreadCnt = summary?.unreadCnt ?? 0;
        const [menuVisible, setMenuVisible] = useState(false);
        const [menuPosition, setMenuPosition] = useState<{x: number, y: number}>({x: 0, y: 0});

        function handleDeleteTopic() {
            const mid = summary?.latest?.mid || im.BuildMinMid(topic.tid);
            Promise.all([
                im.SetTopicProps({ tid: topic.tid, hidemid: mid }),
                im.CleanMsg(topic.tid, topic.lsMid)
            ]).then(() => {
                im.SetCache(`${topic.tid}_latest_msgs`, []);
            });
        }
        function handleToTopTopic() {
            const t = time.toUnixMillSecond(time.now());
            const order = topic.order > 0 ? 0 : t;
            showLoading();
            im.SetTopicProps({ tid: topic.tid, order: order }).then((res) => {
                if (res.error) {
                    // todo 界面提示
                }
                hideLoading();
            });
        }
        function handleReadTopic() {
            if (summary && summary.latest) {
                const lsMid = summary.latest.mid;
                im.SetTopicProps({ tid: topic.tid, lsMid: lsMid }).then((res) => {
                    if (res.error) {
                        // todo 界面提示
                    }
                });
            }
        }
        function handleContextMenu(e: any) {
            e.preventDefault();
            setMenuPosition({ x: e.clientX, y: e.clientY });
            setMenuVisible(true);
        }
        function handleMenuAction(type: number) {
            setMenuVisible(false);
            switch (type) {
                case 1:
                    handleToTopTopic();
                    break;
                case 2:
                    handleReadTopic();
                    break;
                case 3:
                    handleDeleteTopic();
                    break;
            }
        }

        return (
            <>
                <View onContextMenu={handleContextMenu} style={{ width: '100%' }}>
                    {children}
                </View>
                {menuVisible && (
                    <Modal
                        transparent
                        visible={menuVisible}
                        animationType="fade"
                        onRequestClose={() => setMenuVisible(false)}
                    >
                        <Pressable style={{ position: 'absolute', left: 0, top: 0, right: 0, bottom: 0 }} onPress={() => setMenuVisible(false)} />
                        <View style={{ position: 'absolute', left: menuPosition.x, top: menuPosition.y, backgroundColor: '#fff', borderRadius: 6, elevation: 5, shadowColor: '#000', shadowOpacity: 0.1, shadowRadius: 8, minWidth: 120 }}>
                            <Pressable style={{ padding: 12 }} onPress={() => handleMenuAction(1)}>
                                <Text>{topic.order > 0 ? Str_TopicUntop : Str_TopicTop}</Text>
                            </Pressable>
                            {unreadCnt > 0 && (
                                <Pressable style={{ padding: 12 }} onPress={() => handleMenuAction(2)}>
                                    <Text>{Str_MarkRead}</Text>
                                </Pressable>
                            )}
                            <Pressable style={{ padding: 12 }} onPress={() => handleMenuAction(3)}>
                                <Text style={{ color: '#dd2c00' }}>{Str_DelAndClean}</Text>
                            </Pressable>
                        </View>
                    </Modal>
                )}
            </>
        );
    }
);
